<div matSnackBarLabel>
  <span *ngIf="data.message" [innerHTML]="data.message"></span>
  <mat-spinner *ngIf="data.loading" class="loader" [diameter]="40"></mat-spinner>
</div>
<div matSnackBarActions>
  <span *ngIf="data.message">
    <button mat-button matSnackBarAction (click)="snackBar.dismiss()">{{ 'f.alert.close' | translate }}</button>
  </span>
</div>
